import { ISavedMinerSetting } from "@store/savedMinerSettings/actionTypes";

const KEY = "CLONED";

export const saveSettingsToStorage = (settings: ISavedMinerSetting[]) => {
  const data = JSON.stringify(settings);
  localStorage.setItem(KEY, data);
};

export const getSettingsFromStorage = () => {
  const data = localStorage.getItem(KEY);

  return data ? JSON.parse(data) : [];
};

export const clearSettingsFromStorage = () => {
  localStorage.removeItem(KEY);
};
